// pages/Support.js
import Card from '../components/Card';
import Button from '../components/Button';

const Support = () => (
  <div className="page">
    <h1 className="title">マーケティングプラン製作サポート</h1>

    <Card title="マーケティングプラン製作サポートシステム">
      <p>あらゆる業種のマーケティングプランを製作するためのAIアプリをご提供。</p>
      <ul className="link-list">
        <li><Button onClick={() => window.open('https://sns-strategy-system.myou-kou.com/', '_blank')}>アプリへアクセス</Button></li>
        <li><a className="link-button" href="https://example.com/video/marketing-demo" target="_blank" rel="noopener noreferrer">デモ動画を見る</a></li>
        <li><a className="link-button" href="/downloads/marketing_manual.pdf" target="_blank" rel="noopener noreferrer">マニュアルを見る</a></li>
      </ul>
    </Card>
  </div>
);

export default Support;